import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2df058fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.rem.css?vue&type=style&index=0&id=2df058fc&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=2df058fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df058fc",
  null
  
)

export default component.exports